import React from "react";

/** @deprecated */
export type FormLabelProps = {
  /** the input label */
  label?: React.ReactNode;
  /** the id of the input this label is for */
  inputId: string;
  /** the id of this label */
  id?: string;
  /** show the required label flair? */
  isRequired?: boolean;
  /** disable the label? */
  isDisabled?: boolean;
  /** If set, the text is shown next to the label */
  description?: React.ReactNode;
  /** If true, the description will be shown in a tooltip on an info icon next to the label */
  shouldShowDescriptionInTooltip?: boolean;
  /** If isRequired is false, an "Optional" label flair will be shown. This will control if it's shown at all. */
  isOptionalTextShown?: boolean;
};

/** @deprecated */
export type InputStackProps = {
  name: string;
  label?: React.ReactNode;
  className?: string;
  style?: React.CSSProperties;
  // Made more permissive to allow for null children
  children: React.ReactNode;
  isDisabled: boolean;
};

export const InputTypes = {
  NUMBER: "number",
  STRING: "string",
  GEO_POINT: "geo_point",
  BOOLEAN: "boolean",
  INTEGER: "integer",
  PICK_LIST: "pick-list",
  MULTI_PICK_LIST: "multi-pick-list",
  LOOKUP: "lookup",
  DATE: "date",
  DATE_TIME: "date-time",
  DATE_TIME_RANGE: "date-time-range",
  FILE: "file",
  MULTI_FILE: "multi-file",
} as const;

export type InputTypesType = (typeof InputTypes)[keyof typeof InputTypes];
